module.exports = __webpack_public_path__ + "media/images/products/products/b2-3eced38ec879231a71407d1779df32bb.jpg";